module.exports = __webpack_public_path__ + "static/media/more-option.f594f784.svg";